import { useState } from "react";
import Head from "next/head";
import useUser from "../lib/useUser";
import { Layout } from "../common/Layout";
import { Imgix, Hero, Section } from "../common/UI";
import withSession from "../lib/session";
import {
  Container,
  Grid,
  Button,
  Box,
  Typography,
  Divider,
  Paper,
  Link,
} from "@mui/material";

import { PartnersList } from "../modules/Partners/List";

export default function SurfPage() {
  return (
    <Layout>
      <Grid item>
        <Hero
          minHeight={400}
          bgImg="https://bigsurf1.imgix.net/zane-plus3_onbeach2.jpg?w=1800"
        >
          <Box sx={{}}>
            <Typography
              variant="h2"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Surf Lessons
            </Typography>
          </Box>
          <Box sx={{}}>
            <Typography
              variant="h4"
              sx={{
                color: "white",
                textShadow: "0 1px 0 black",
                textAlign: "center",
              }}
            >
              Individual and Group surf instruction at <br />
              world-renowned beaches on the scenic Monterey Peninsula
            </Typography>
          </Box>
        </Hero>

        <Section>
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Box sx={{ padding: "24px 0" }}>
                  <Typography variant="h5">Our Lessons are</Typography>
                  <Typography variant="h3">The Best in Monterey</Typography>
                  <p>
                    Any group size and all experience levels are welcome.
                    Multi-day discounts available.
                  </p>
                  <div>
                    <div>
                      - <Link href="#private">Individual Lessons</Link>
                    </div>
                    <div>
                      - <Link href="#group">Private Group Lessons (2-4)</Link>
                    </div>
                    <div>
                      - <Link href="#public">Join a Group</Link>
                    </div>
                    <div>
                      - <Link href="#large">Big Groups (5+)</Link>
                    </div>
                    <div>
                      - <Link href="#corp">Corporate Team Building</Link>
                    </div>
                    <div>
                      - <Link href="#surfit">SurFit Classes</Link>
                    </div>
                    {/* {{#compare (kv 'misc.budget') '==' 'yes'}} */}
                    <div>
                      - <Link href="#budget">Budget Lessons</Link>
                    </div>
                    {/* {{/compare}} */}
                    {/* {{#compare (kv 'misc.surf-buddy.enabled') '==' 'yes'}} */}
                    {/* <div>
                    - <Link href="#buddy">{{kv 'page.lessons.surf-buddy.link-text'}}</Link>
                    </div> */}
                    {/* {{/compare}} */}
                  </div>
                </Box>
              </Grid>
              <Grid item md={6}>
                <Box sx={{ padding: "24px 0" }}>
                  <br />
                  <br />
                  <br />
                  <Typography variant="h4">
                    Included in every Lesson:
                  </Typography>

                  <div>- 2 hours guided and supervised instruction</div>

                  <div>
                    - Professional Grade / Top-of-the-Line 5/4mm wetsuits
                  </div>

                  <div>- Comfort-fit booties</div>

                  <div>
                    - Profession Grade surfboard and leash (wide variety to suit
                    all experience levels)
                  </div>

                  <div>- Gloves and hoods available upon request</div>

                  <div>- Life jackets for young children if requested</div>

                  <div>- Sunscreen if you need it</div>

                  <div>- An experience you will never forget!</div>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />
        <br />

        <Section id="private">
          <Container>
            <Typography variant="h3">
              Individual Lessons
              {/* <span class="is-pulled-right is-size-7">
                    <Link href="#menu">
                      top
                    </Link>
                  </span> */}
            </Typography>

            <Grid container spacing={3}>
              <Grid item md={6} id="beginner">
                <Typography variant="h4">Private Lesson</Typography>

                <Typography variant="h6">
                  {/* <Link href="/book/create?type=single">
                    $199
                  </Link> */}
                  <Link href="https://fareharbor.com/embeds/book/bigsurfadventures/items/556939/?full-items=yes&flow=1210171">
                    $175
                  </Link>
                </Typography>
                <p>
                  <strong>One-on-one</strong> instruction customized to
                  accelerate the student’s ability to comprehend and apply the{" "}
                  <strong>fundamentals of surfing</strong>. Those who select
                  this option should find that they leave with a complete
                  understanding of optimal position, paddling, and pop up.
                  Instruction includes a demonstration on the beach, followed by
                  student practice time on the water. After completing their
                  first lesson, participants should be able to rent or purchase
                  equipment and surf with confidence. Additional lessons are
                  usually needed to learn{" "}
                  <strong>
                    advanced techniques such as wave selection, optimal entry
                    points, turning, tricking and duck diving. Knowledge of
                    surfer etiquette, board selection, reading surf reports and
                    oceanography will also be discussed.
                  </strong>{" "}
                  The faster students learn, the more they can be taught during
                  the lesson!
                </p>
                {/* <p>($25 off multi-day discount)</p> */}
                <p>
                  <Button
                    // href="/book/create?type=single"
                    href="https://fareharbor.com/embeds/book/bigsurfadventures/items/556939/?full-items=yes&flow=1210171"
                    variant="contained"
                    color="success"
                  >
                    Book Now!
                  </Button>
                </p>
              </Grid>

              <Grid item md={6} id="master">
                <Typography variant="h4">Master Class</Typography>

                <Typography variant="h6">
                  {/* <Link href="/book/create?type=single&single=master"> */}
                  <Link href="https://fareharbor.com/embeds/book/bigsurfadventures/items/556970/?full-items=yes&flow=1210171">
                    {/* ${{kv 'price.private-master'}} */}
                    $250
                  </Link>
                </Typography>
                <p>
                  This option is like the{" "}
                  <strong>private lesson, but with a few extra perks.</strong>{" "}
                  The length has been extended to <strong>3 hours</strong>{" "}
                  instead of 2. Students will ride multiple boards during their
                  lesson and will receive priority during scheduling (certain
                  time windows each day are more likely to produce quality
                  waves). Students will have the option of having drone video
                  taken of them surfing towards the end of the lesson (depending
                  on availability and weather conditions).
                  <br />
                  <br />
                  <strong>
                    Advanced instruction for surfers who want to take the next
                    step.
                  </strong>
                  <br />
                  Expert-level boards and personalized instruction.
                </p>
                <p>($25 off multi-day discount)</p>
                <p>
                  <Button
                    // href="/book/create?type=single&single=master"
                    href="https://fareharbor.com/embeds/book/bigsurfadventures/items/556970/?full-items=yes&flow=1210171"
                    variant="contained"
                    color="success"
                  >
                    Book Now!
                  </Button>
                </p>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Divider />
        <br />

        <Section id="group">
          <Container>
            <Typography variant="h3">
              Private Group Lessons
              {/* <span class="is-pulled-right is-size-7">
                <Link href="#menu">top</Link>
              </span> */}
            </Typography>

            <p>
              Private groups are a great choice for{" "}
              <strong>families, couples, or friends</strong> to enjoy surfing
              together. During private group lesson students will receive
              similar training to our individual private lessons. The{" "}
              <strong>focus will be on the fundamentals</strong>, as well as
              knowledge on <strong>surfer etiquette and ocean safety.</strong>{" "}
              Our lessons begin with a <strong>quick demonstration</strong> on
              the beach and practice time. Followed immediately by a{" "}
              <strong>long surf session</strong> in the waves were students put
              their beach practice to the test under instructor guidance and
              supervision. Afterward we will{" "}
              <strong>
                discuss successes and things to think about/work on
              </strong>{" "}
              before taking another lesson. Different discounts are offered
              based on the number of people in your party.
            </p>

            <br />
            <br />

            <Grid container spacing={3}>
              <Grid item sx={{ flex: 1 }}>
                <Paper variant="outlined" sx={{ padding: 2 }}>
                  <Typography variant="h5">Private Couple (2)</Typography>
                  <Typography variant="h6">
                    {/* <Link href="/book/create?type=group&people=2"> */}
                    <Link href="https://fareharbor.com/embeds/book/bigsurfadventures/items/556978/?full-items=yes&flow=1210171">
                      {/* ${{kv 'price.private-group-2'}}/person */}
                      $150 / person
                    </Link>
                  </Typography>
                </Paper>
              </Grid>

              <Grid item sx={{ flex: 1 }}>
                <Paper variant="outlined" sx={{ padding: 2 }}>
                  <Typography variant="h5">Private Triple (3)</Typography>
                  <Typography variant="h6">
                    <Link href="https://fareharbor.com/embeds/book/bigsurfadventures/items/558304/?full-items=yes&flow=1210171">
                      {/* ${{kv 'price.private-group-3'}}/person */}
                      $125 / person
                    </Link>
                    {/* <span style={{ fontStyle: "italic" }}>Call Us!</span> */}
                  </Typography>
                </Paper>
              </Grid>

              <Grid item sx={{ flex: 1 }}>
                <Paper variant="outlined" sx={{ padding: 2 }}>
                  <Typography variant="h5">Private Quad (4)</Typography>
                  <Typography variant="h6">
                    <Link href="https://fareharbor.com/embeds/book/bigsurfadventures/items/557000/?full-items=yes&flow=1210171">
                      {/* ${{kv 'price.private-group-4'}}/person */}
                      $100 / person
                    </Link>
                    {/* <span style={{ fontStyle: "italic" }}>Call Us!</span> */}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Section>

        <br />
        <br />
        <Divider />
        <br />

        <Section id="public">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h3">
                  Join a Group Lesson
                  {/* <span class="is-pulled-right is-size-7">
                    <Link href="#menu">top</Link>
                  </span> */}
                </Typography>
                <Typography variant="h6">
                  {/* <Link href="/book/create?type=single"> */}
                  {/* ${{kv 'price.join-group'}}/person */}
                  {/* $99 / person
                  </Link> */}
                  {/* <span style={{ fontStyle: "italic" }}>Call Us!</span> */}
                  <Link href="https://fareharbor.com/embeds/book/bigsurfadventures/items/567828/?full-items=yes&flow=1210171">
                    {/* ${{kv 'price.large-group'}}/person */}
                    $99 / person
                  </Link>
                </Typography>
                <p>
                  Singles and groups of 2-3 looking to{" "}
                  <strong>save a few bucks</strong> have the option of joining a
                  small group lesson. This option is great for newbies and
                  travelers to{" "}
                  <strong>share their surfing journey with others</strong>.
                  Students will be paired with up-to 3 other individuals (max 4
                  people per class). The instructor will be assisting all
                  attendees as much as possible, however there will be a bit
                  less individual attention than our private lessons. The
                  curriculum will be the{" "}
                  <strong>same as private group lessons</strong>. Must be 16 or
                  older to join a group.
                </p>
                {/* <br />
                <p>
                  <Button
                    variant="contained"
                    fullWidth
                    href="/book/create?type=join"
                  >
                    Join a Group Lesson
                  </Button>
                </p> */}
              </Grid>

              <Grid item md={6} sx={{ textAlign: "center" }}>
                <Imgix
                  src="https://bigsurf1public.imgix.net/public/dd508263-52c7-4884-8699-55e586569fc9.jpg"
                  width={700}
                  boxProps={{
                    sx: {
                      "> img": {
                        width: "100%",
                        boxShadow: "0px 5px 15px 15px rgba(165,165,165,0.38)",
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Section>

        <br />
        <Divider />
        <br />

        <Section id="large">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h3">
                  Big Group (5+)
                  {/* <span class="is-pulled-right is-size-7">
                    <Link href="#menu">top</Link>
                  </span> */}
                </Typography>
                <Typography variant="h6">
                  Extra instructors and more time to catch waves
                </Typography>
                <Typography variant="h6">
                  <Link href="https://fareharbor.com/embeds/book/bigsurfadventures/items/557009/?full-items=yes&flow=1210171">
                    {/* ${{kv 'price.large-group'}}/person */}
                    $90 / person
                  </Link>
                </Typography>
                <p>
                  Our big group option is a wonderful way for large parties to
                  experience surfing and also have access to{" "}
                  <strong>additional equipment</strong>.{" "}
                  <strong>Additional instructors</strong> will be involved to
                  facilitate <strong>safety, guidance and supervision</strong>.
                  We spend the <strong>most amount of time in the water</strong>{" "}
                  with big group lessons to insure everyone has a chance to ride{" "}
                  <strong>multiple waves</strong>. Any group size can be
                  accommodated.{" "}
                  <strong>
                    Start times may vary depending on water conditions
                  </strong>
                  .
                </p>
                <br />
                <p>
                  <Button
                    variant="contained"
                    fullWidth
                    // href="/book/create?type=large-group&people=6"
                    href="https://fareharbor.com/embeds/book/bigsurfadventures/items/557009/?full-items=yes&flow=1210171"
                  >
                    Book a Group Rate Today!
                  </Button>
                </p>
              </Grid>
              <Grid item md={6}>
                <Imgix
                  src="https://bigsurf1public.imgix.net/public/b4e530f5-c5ba-48e6-a7fd-602427c796b5.jpg"
                  width={700}
                  boxProps={{
                    sx: {
                      "> img": {
                        width: "100%",
                        boxShadow: "0px 5px 15px 15px rgba(165,165,165,0.38)",
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Section>

        <br />
        <Divider />
        <br />

        <Section id="corp">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h3">
                  Corporate Team Building
                  {/* <span class="is-pulled-right is-size-7">
                    <Link href="#menu">top</Link>
                  </span> */}
                </Typography>
                <Typography variant="h6">Prices Vary</Typography>
                <Typography variant="body1">
                  Corporate lessons are a great option for{" "}
                  <strong>team building</strong> with a little something for
                  everyone. We will host a{" "}
                  <strong>variety of activities</strong>: surfing, boogie
                  boarding, SUP, smash ball, relay races, beach volley ball
                  matches, bocce ball, kite building. We provide{" "}
                  <strong>catered lunch</strong> (pizza, Thai food, tacos, or
                  poke) and snacks. We do have additional packages that include
                  a <strong>day hike</strong>, 9 hole <strong>golf trip</strong>{" "}
                  and <strong>wine tour</strong> in gorgeous Carmel Valley.
                  Reservations must be booked in advance and prices vary based
                  on the number of people and range of activities.
                </Typography>

                <br />
                <p>
                  <Button
                    variant="contained"
                    fullWidth
                    // href="/book/create?type=corp"
                    href="mailto:hello@bigsurfadventures.com?subject=Corporate%20Surf%20Party"
                  >
                    Contact Us if you're interested in Corporate Surf Parties!
                  </Button>
                </p>
              </Grid>
              <Grid item md={6}>
                <Imgix
                  src="https://bigsurf1public.imgix.net/public/f19be2c2-eccd-4f08-ac9f-cca5cc06fefa.jpg"
                  width={700}
                  boxProps={{
                    sx: {
                      "> img": {
                        width: "100%",
                        boxShadow: "0px 5px 15px 15px rgba(165,165,165,0.38)",
                        borderRadius: "10px",
                      },
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Section>

        <br />
        <Divider />
        <br />

        <Section id="surfit">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h3">
                  SurFit Fitness Classes
                  {/* <span class="is-pulled-right is-size-7">
                    <Link href="#menu">top</Link>
                  </span> */}
                </Typography>
                <p>
                  The SurFit fitness weekly class is designed to get people{" "}
                  <strong>out of the gym</strong> and enjoying functional{" "}
                  <strong>fitness outdoors</strong>. We here at Big Surf love
                  healthy lifestyles and combining{" "}
                  <strong>mind body and nature</strong> all into one. Our
                  classes are for ages <strong>15+</strong>. Participates can
                  expect a <strong>2-3 hour class</strong> that varies week to
                  week. Activities will include: surfing, beach yoga, surfboard
                  yoga, stand up paddle boarding, dune climbs, paddle tug of
                  war, stretching, body weight exercises, group relays, and HIIT
                  workouts.
                </p>
                <br />
                <p>
                  <Button
                    variant="contained"
                    fullWidth
                    // href="/book/create?type=surfit"
                    href="mailto:hello@bigsurfadventures.com?subject=SurFit%20Class"
                  >
                    Contact Us For Upcoming Classes
                  </Button>
                </p>
              </Grid>
              <Grid item md={6}>
                <Imgix
                  src="https://bigsurf1public.imgix.net/public/4201bf2d-28a6-41d8-9b22-ec1c6ea4cc48.jpg"
                  // width={600}
                  height={400}
                  boxProps={{
                    sx: {
                      "> img": {
                        width: "100%",
                        boxShadow: "0px 5px 15px 15px rgba(165,165,165,0.38)",
                        borderRadius: "10px",
                      },
                    },
                  }}
                  imgixParams={{
                    fit: "crop",
                    crop: "focalpoint",
                    ar: "4:3",
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Section>

        <br />
        <Divider />
        <br />

        <Section id="budget">
          <Container>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <Typography variant="h3">
                  Budget Surf Lessons
                  {/* <span class="is-pulled-right is-size-7">
                    <Link href="#menu">top</Link>
                  </span> */}
                </Typography>
                <p>
                  We offer Budget Surf Lessons occasionally at a reduced price
                  for locals (~2 hours around Monterey). Join our email list to
                  be notified when we're having a surf sesh!
                </p>
                <p>
                  <div
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: `<div id="mc_embed_shell">
      <link href="//cdn-images.mailchimp.com/embedcode/classic-061523.css" rel="stylesheet" type="text/css">
  <style type="text/css">
        #mc_embed_signup{background:#fff; clear:left; font:14px Helvetica,Arial,sans-serif; width: 300px;}
        @media (min-width: 1000px) {
          #mc_embed_signup{
            width: 500px;
          }
        }
        /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
           We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
</style>
<div id="mc_embed_signup">
    <form action="https://bigsurfadventures.us10.list-manage.com/subscribe/post?u=9154e622e6b6eb2d92e86c441&amp;id=d4f8914d30&amp;f_id=0034e4e5f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">
        <div id="mc_embed_signup_scroll">
            <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
            <div class="mc-field-group"><label for="mce-EMAIL">Email Address <span class="asterisk">*</span></label><input type="email" name="EMAIL" class="required email" id="mce-EMAIL" required="" value=""></div>
        <div id="mce-responses" class="clear foot">
            <div class="response" id="mce-error-response" style="display: none;"></div>
            <div class="response" id="mce-success-response" style="display: none;"></div>
        </div>
    <div aria-hidden="true" style="position: absolute; left: -5000px;">
        /* real people should not fill this in and expect good things - do not remove this or risk form bot signups */
        <input type="text" name="b_9154e622e6b6eb2d92e86c441_d4f8914d30" tabindex="-1" value="">
    </div>
        <div class="optionalParent">
            <div class="clear foot">
                <input type="submit" name="subscribe" id="mc-embedded-subscribe" class="button" value="Join Email List">
            </div>
        </div>
    </div>
</form>
</div>
<script type="text/javascript" src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"></script><script type="text/javascript">(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[4]='PHONE';ftypes[4]='phone';fnames[3]='ADDRESS';ftypes[3]='address';fnames[5]='BIRTHDAY';ftypes[5]='birthday';}(jQuery));var $mcj = jQuery.noConflict(true);</script></div>
`,
                    }}
                  ></div>
                </p>
              </Grid>
              <Grid item md={6}>
                <Imgix
                  src="https://bigsurf1public.imgix.net/public/a9f660fb-bfd3-42c6-8956-e13f92541178.jpg?"
                  // width={600}
                  height={400}
                  boxProps={{
                    sx: {
                      "> img": {
                        width: "100%",
                        boxShadow: "0px 5px 15px 15px rgba(165,165,165,0.38)",
                        borderRadius: "10px",
                      },
                    },
                  }}
                  imgixParams={{
                    fit: "crop",
                    crop: "focalpoint",
                    ar: "4:3",
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Section>

        <Hero minHeight={400} bg="#35baf6">
          <Typography
            variant="h2"
            sx={{
              color: "white",
              textShadow: "0 1px 0 black",
              textAlign: "center",
            }}
          >
            Whether it's your first time or you're eager to improve your skills,
            <br />
            Big Sur Surf Lessons will accommodate your learning needs!
          </Typography>
        </Hero>

        {/* 
          {{#compare (kv 'misc.budget') '==' 'yes'}}
          <div id="budget" class="full-width has-background-black2">

            <div class="section">
              <div class="container">

                <div class="columns">
                  <div class="column is-6">

                    <h2 class="title is-3">
                      Budget Lessons
                      <span class="is-pulled-right is-size-7">
                        <Link href="#menu">
                          top
                        </Link>
                      </span>
                    </h2>
                    <div class="content">
                      {{{marked (kv 'lessons.budget.description')}}}
                    </div>
                    <br />
                    <p>
                      <Link href="/budget" class="button is-success is-fullwidth">
                        {{{kv 'page.lessons.budget.button-text'}}}
                      </Link>
                    </p>
                  </div>

                  <div class="column is-6 has-text-centered">
                    {{{customImage 'page.lessons.budget.image-1' 'w=600' }}}
                  </div>
                </div>

              </div>
            </div>
          </div>
          {{/compare}}

          {{#compare (kv 'misc.surf-buddy.enabled') '==' 'yes'}}
          <div id="buddy" class="full-width has-background-black2">

            <div class="section">
              <div class="container">

                <div class="columns">
                  <div class="column is-6">

                    <h2 class="title is-3">
                      {{kv 'page.lessons.surf-buddy.title'}}
                      <span class="is-pulled-right is-size-7">
                        <Link href="#menu">
                          top
                        </Link>
                      </span>
                    </h2>
                    <div class="content">
                      {{{marked (kv 'page.lessons.surf-buddy.description')}}}
                    </div>
                    <br />
                    <p>
                      <Link href="/buddy" class="button is-success is-fullwidth">
                        {{kv 'page.lessons.surf-buddy.button-text'}}
                      </Link>
                    </p>
                  </div>

                  <div class="column is-6 has-text-centered">
                    {{{customImage 'page.lessons.surf-buddy.image-1' 'w=600' }}}
                  </div>
                </div>

              </div>
            </div>
          </div>
          {{/compare}}


        </div> */}
      </Grid>
    </Layout>
  );
}

// export const getServerSideProps = withSession(async function ({ req, res }) {
//   const user = req.session.get("user") ?? null;
//   return {
//     props: { user },
//   };
// });
